import { createAction } from '@reduxjs/toolkit';

export const openNewOrExistingDialog = createAction('[New or Existing] openNewOrExistingDialog');
export const openNewTrip = createAction('[New or Existing] openNewTrip');
export const openExistingTrip = createAction('[New or Existing] openExistingTrip');
export const setRequestingAgencyName = createAction('[New or Existing] setRequestingAgencyName');
export const setRequestingAgencyId = createAction('[New or Existing] setRequestingAgencyId');
